import React, { useEffect } from "react";
import ReactModal from "react-modal";

import { ModalHeader } from "..";

interface FullPageModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  component: string;
  footer?: React.ReactNode;
}

// Set app element for ReactModal if not already set
if (typeof document !== "undefined") {
  const rootElement = document.getElementById("root");
  if (rootElement && !ReactModal.defaultStyles.overlay) {
    ReactModal.setAppElement("#root");
  }
}

export const FullPageModal: React.FC<FullPageModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  component,
}): JSX.Element => {
  useEffect(() => {
    // Ensure app element is set
    if (typeof document !== "undefined") {
      const rootElement = document.getElementById("root");
      if (rootElement) {
        ReactModal.setAppElement("#root");
      }
    }
  }, []);

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldFocusAfterRender={true}
      shouldReturnFocusAfterClose={true}
      ariaHideApp={false}
      style={{
        content: {
          width: "100vw",
          height: "100vh",
          position: "fixed",
          maxWidth: "100vw",
          inset: "0px",
          margin: "0px",
          borderRadius: "0",
        },
      }}
    >
      <div
        className="flex flex-col h-screen"
        data-testid={`${component}-modal-container`}
      >
        <ModalHeader
          title={title}
          handleClose={onClose}
          component={component}
          isFullPageModal={true}
        />

        <div className="flex-1 overflow-auto">{children}</div>

        {footer && <div className="flex-shrink-0">{footer}</div>}
      </div>
    </ReactModal>
  );
};
